import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import Header from './Header';
import Main from './Main';
import Auth from './Auth';
import './App.css';


// require('gun/sea')
//<Route path="/" component={App}>
//    </Route>
class App extends Component {
 constructor() {
   
    super();

    this.database = {}

    this.state = {
     user: { authenticated: false, status: null, uid: null, email: null }
   }
   
   Auth.connect( (authData, database) => {
      if (authData) {

        this.database = database;

        const user = {
          status: authData.status,
          email: authData.email || null,
          authenticated: authData.authenticated,
          uid: authData.uid
        };
        this.setState({
          user: {...user}
        });
        if(authData && authData.authenticated) {
          //const {history} = this.props;
        //           history.push('/');
        }
        //console.log("UserData:");
        //console.log(user);
      }
    });
   
 };
  
  signIn = (provider, email, pwd) => {
    Auth.signIn(provider, email, pwd);
  };

  signUp = (provider, email, pwd) => {
    Auth.signUp(provider, email, pwd);
  };

  signOut = () => {
    //console.log('signing out...');
    Auth.signOut();
  };
  
  render() {
    return (
      <div>
        <Header signUp={this.signUp} signIn={this.signIn} signOut={this.signOut} user={this.state.user} />
        <Main   signUp={this.signUp} signIn={this.signIn} signOut={this.signOut} user={this.state.user} />
      </div>
    );
  }
}

export default withRouter(App);



// WEBPACK FOOTER //
// ./src/App.js